<template>
  <div class="container">
    <div
      v-if="loading"
      class="col"
    >
      Chargement en cours
    </div>
    <div
      v-if="!loading && loadedOnce"
      class="col"
    >
      <div class="row">
        <h2>Résultats : {{ numberOfCoins }} pièce{{ numberOfCoins > 1 ? 's': '' }} <span v-if="name">({{ filteredCoins().length }} filtrées)</span></h2>
      </div>
      <div class="row filter">
        <div class="col">
          <label
            for="filter"
            class="filter-label"
          >Filtrer par nom</label>
        </div>
        <div class="col">
          <input
            id="filter"
            v-model="name"
            type="text"
            class="field filter-field"
          >
        </div>
      </div>
      <div class="row">
        <div class="wrapper">
          <collection-item
            v-for="coin in filteredCoins()"
            :key="coin.id"
            :coin="coin"
          ></collection-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CollectionItem from './collection-item';
  import NumistaAPI from './../tools/NumistaAPI';

  export default {
    name: 'SearchResult',
    components: {
      CollectionItem,
    },
    props: ['search'],
    data() {
      return {
        loading: false,
        loadedOnce: false,
        coins: [],
        numberOfCoins: 0,
        amountOfPages: 0,
        filter: {},
        error: null,
        name: '',
        pageToSearch: 1,
      };
    },
    watch: {
      search: function (newVal, oldVal) {
        if (newVal && newVal !== '' && newVal !== oldVal) {
          this.pageToSearch = 1;
          this.fetchData();
        }
      }
    },
    created() {
      this.coins = [];
    },
    methods: {
      fetchData() {
        this.loading = true;
        this.fetch()
          .then((payload) => {
            this.numberOfCoins = payload.total_coins;
            this.filter = payload.filter;
            this.amountOfPages = payload.pages.max;
            this.loading = false;
            this.loadedOnce = true;
            this.fetchMore();
          })
          .catch(() => {
            this.loading = false;
          });
      },
      filteredCoins() {
        return this.coins.filter(coin => (this.name === '' || coin.name.toLowerCase().indexOf(this.name.toLowerCase()) >= 0));
      },
      fetchMore() {
        if (this.pageToSearch < this.amountOfPages) {
          this.pageToSearch++;
          this.fetch()
            .then(() => this.fetchMore());
        }
      },
      fetch() {
        return NumistaAPI.search(this.search, this.pageToSearch)
          .then((payload) => {
            this.coins = this.coins.concat(payload.list.map(coin => Object.assign({}, coin, { images: coin.image })));
            return payload;
          });
      }
    }
  };
</script>

<style scoped>
    h2 {
        margin: 0.5em 0 0 0;
    }

    .row {
        justify-content: center;
    }

    .col {
        width: 100%;
    }

    .wrapper {
        margin: 0 5px;
        display: flex;
        flex-flow: row;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .row.filter {
        margin-top: 0.5em;
    }

    .filter .col {
        width: auto;
        justify-content: center;
    }

    .filter-label {
        margin-right: 1em;
        font-size: 1.1em;
    }

    .filter-field {
        min-width: 175px;
    }
</style>
